import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setContinuePlayGame, setSelectedCategory } from 'src/store/app/actions';
import { useConnectedAction } from './use-connected-action';

const useGbMessages = (): void => {
  const navigate = useNavigate();

  const _setSelectedCategory = useConnectedAction(setSelectedCategory);
  const _setContinuePlayGame = useConnectedAction(setContinuePlayGame);

  const NAVIGATION_MAP: any = {
    openSpinAndGoTournament: (data: { tournamentId: number }) => {
      const { tournamentId } = data;
      _setSelectedCategory('casinoTournament');
      navigate('/category/casino-tournament');
      if (tournamentId) {
        window.__gdlib?.notify('SPIN_AND_GO_STARTED', { tournamentId });
        window.__gdlib?.callRegisteredCB('closeGameBoxLobbyWidget');
      }
    },
    openWheelOfFortune: () => {
      _setContinuePlayGame(true);
      window.__gdlib?.callRegisteredCB('openMiniGame');
    },
    goToLobby: () => {
      _setSelectedCategory('home');
      navigate('/');
    },
    goToGos: () => {
      _setSelectedCategory('casinoTournament');
      navigate('/category/casino-tournament');
    },
    goToFunLobby: () => {
      window.__gdlib?.notify('CLOSE_GAME_BOX');
      window.__gdlib?.callRegisteredCB('closeGameBoxLobbyWidget');
      navigate('/category/fun-mission');
    },
  };
  useEffect(() => {
    (window as any).gdMessagesNavigateTo = (path: any, data: any) => {
      if (NAVIGATION_MAP[path]) {
        NAVIGATION_MAP[path](data);
      }
    };
  }, []);
};

export default useGbMessages;
